import api from '@/services/api';

/**
 * Upload an original exam recording. The server drafts a SOAP note.
 * @param {number|string} subjectId
 * @param {File} file
 * @param {'phone'|'import'} source
 */
export async function startSoapDictation(subjectId, file, source) {
  const form = new FormData();
  form.append('file', file);
  form.append('source', source);
  const response = await api.post(
    `/veterinary/patients/${subjectId}/soap-dictation/`,
    form,
    {
      timeout: 300000,
      headers: { 'Content-Type': undefined },
      transformRequest: [(data) => data],
    },
  );
  return response.data;
}

/**
 * @param {number|string} subjectId
 * @param {number|string} documentId
 */
export async function getSoapDictation(subjectId, documentId) {
  const response = await api.get(
    `/veterinary/patients/${subjectId}/soap-dictation/${documentId}/`,
  );
  return response.data;
}

/**
 * @param {number|string} subjectId
 * @param {number|string} documentId
 * @param {object} edits
 */
export async function confirmSoapDictation(subjectId, documentId, edits) {
  const response = await api.post(
    `/veterinary/patients/${subjectId}/soap-dictation/${documentId}/confirm/`,
    edits,
  );
  return response.data;
}

/**
 * @param {number|string} subjectId
 * @param {number|string} documentId
 */
export async function discardSoapDictation(subjectId, documentId) {
  const response = await api.post(
    `/veterinary/patients/${subjectId}/soap-dictation/${documentId}/discard/`,
  );
  return response.data;
}
